import { api } from '../../lib/api';

export const approvalsApi = {
  // Out-of-office approval delegations (self-service).
  listMyDelegations: () => api.get('/approval-delegations'),
  delegationCandidates: () => api.get('/approval-delegations/candidates'),
  createDelegation: (payload) => api.post('/approval-delegations', payload),
  cancelDelegation: (id) => api.del(`/approval-delegations/${id}`),
};
